import { useState } from 'react';
import styled from 'styled-components';

import DefaultInput from 'components/input/DefaultInput';

import { color } from 'asserts/styles/colors';

interface EditDataProps {
  text: string | null;
  setNewData: (newData: string) => void;
  onChangeData: () => void;
}

const LicenseEdit = ({ text, setNewData, onChangeData }: EditDataProps) => {
  const [isEditMode, setIsEditMode] = useState(false);

  const bizlicensenum =
    text === '' || text === '--'
      ? {
          businessNumber1: '',
          businessNumber2: '',
          businessNumber3: ''
        }
      : {
          businessNumber1: text?.split('-')[0],
          businessNumber2: text?.split('-')[1],
          businessNumber3: text?.split('-')[2]
        };

  const [businessNumber, setBusinessNumber] = useState(bizlicensenum);

  const [businessStatus, setBusinessStatus] = useState<{
    status: 'error' | 'warning' | 'success' | 'description' | undefined;
    statusText: string;
  }>({
    status: undefined,
    statusText: ''
  });

  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { value, name } = e.currentTarget;

    if (name.includes('businessNumber')) {
      if (!/^\d*$/.test(value)) {
        setBusinessStatus({
          status: 'description',
          statusText: '숫자만 입력'
        });
      } else {
        setBusinessStatus({
          status: undefined,
          statusText: ''
        });
        setBusinessNumber({ ...businessNumber, [name]: value });
      }
    }
  };

  const bizlicensenum1 = `${businessNumber.businessNumber1}-${businessNumber.businessNumber2}-${businessNumber.businessNumber3}`;

  const handleClick = () => {
    setIsEditMode((prev) => !prev);
  };

  const handleSave = () => {
    setNewData(bizlicensenum1);
    setIsEditMode(false);

    setTimeout(() => {
      onChangeData();
    }, 0);
  };

  return (
    <Wrapper>
      <TextWrapper $isSaveName={isEditMode}>
        {isEditMode ? (
          <InputWrapper>
            <DefaultInput
              name="businessNumber1"
              status={businessStatus.status}
              statusText={businessStatus.statusText}
              onChange={handleChange}
              maxLength={3}
            />
            <p>-</p>
            <DefaultInput name="businessNumber2" onChange={handleChange} maxLength={2} />
            <p>-</p>
            <DefaultInput name="businessNumber3" onChange={handleChange} maxLength={5} />
          </InputWrapper>
        ) : (
          <InputWrapper>
            <h6>{bizlicensenum.businessNumber1}</h6> <p>-</p>
            <h6>{bizlicensenum.businessNumber2}</h6> <p>-</p>
            <h6>{bizlicensenum.businessNumber3}</h6>
          </InputWrapper>
        )}
      </TextWrapper>
      <div>
        {isEditMode ? (
          <ButtonWrapper>
            <button onClick={() => handleSave()}>저장</button>
            <button className="cancel" onClick={handleClick}>
              취소
            </button>
          </ButtonWrapper>
        ) : (
          <ParentWrapper><button onClick={handleClick}>수정</button> <SimpleTextWrapper>'수정'을 클릭하면 수정 할 수 있습니다.</SimpleTextWrapper></ParentWrapper>
        )}
      </div>
    </Wrapper>
  );
};

export default LicenseEdit;

const Wrapper = styled.div`
  display: flex;
  gap: 16px;

  div {
    display: flex;
  }

  button {
    color: ${color.black2};
    font-weight: 500;
  }
`;

const TextWrapper = styled.div<{ $isSaveName: boolean }>`
  display: flex;
  height: 36px;
  border-radius: 4px;
  align-items: center;
  justify-content: center;

  input {
    width: 120px;
  }

  h6 {
    display: flex;
    width: 180px;
    height: 36px;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 18px;
    border: 1px solid rgba(12, 12, 12, 0.05);
    border-radius: 4px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 25px;

  button.cancel {
    position: relative;
    color: ${color.gray500};

    &::after {
      content: '';
      display: inline-block;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: -50%;
      width: 1px;
      height: 12px;
      background: ${color.gray300};
    }
  }
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const ParentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
`;

const SimpleTextWrapper = styled.p`
  display: flex;
  align-items: center;
  color: ${color.blue500};
  gap: 30px;
`;